import render from 'client/render'
import messages from 'messages/ar.ton.json'

render(messages)
